import React from 'react';
import PropTypes from 'prop-types';
import currencyFormatter from 'currency-formatter';
import { SummaryTotals } from '../../../Elements';

const PPlanSummaryTotals = ({
  localInvoice,
  getDownPayment,
  getAdditionalPayments,
  getRemainingBalance
}) =>
  <SummaryTotals>
    <SummaryTotals.Row
      label='Invoice Total'
      value={currencyFormatter.format((localInvoice.total_cents || 0) / 100, {
        code: 'USD'
      })}
    />
    <SummaryTotals.Row
      label='Down Payment'
      minus
      value={currencyFormatter.format(getDownPayment() / 100, { code: 'USD' })}
    />
    <SummaryTotals.Row
      label='Additional Payments'
      minus
      value={currencyFormatter.format(getAdditionalPayments() / 100, {
        code: 'USD'
      })}
    />
    <SummaryTotals.Break />
    <SummaryTotals.Row
      style={{ fontWeight: 'bold' }}
      label='Remaining Balance'
      value={currencyFormatter.format(getRemainingBalance() / 100, {
        code: 'USD'
      })}
    />
  </SummaryTotals>;

PPlanSummaryTotals.propTypes = {
  getRemainingBalance: PropTypes.func.isRequired,
  getAdditionalPayments: PropTypes.func.isRequired,
  getDownPayment: PropTypes.func.isRequired,
  localInvoice: PropTypes.object.isRequired
};

export default PPlanSummaryTotals;



// WEBPACK FOOTER //
// ./webpack/components/Document/Sections/PaymentPlan/SummaryTotals.js